import type { FC } from 'react';
import { useState } from 'react';
import BottomSheet from '../BottomSheet';
import * as S from './styles';
import { ChevronDownIcon } from '../../../../../assets/icons/ChevronDownIcon';

export interface SelectOption {
  value: string;
  label: string;
}

interface MobileSelectProps {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  title?: string;
}

export const MobileSelect: FC<MobileSelectProps> = ({ options, value, onChange, title = 'Sort' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedOption = options.find((option) => option.value === value);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleSelect = (newValue: string) => {
    onChange(newValue);
    handleClose();
  };

  return (
    <>
      <S.SelectButton onClick={handleOpen}>
        {title}
        <span>
          <ChevronDownIcon />
        </span>
      </S.SelectButton>

      <BottomSheet isOpen={isOpen} onClose={handleClose} title={title}>
        <S.OptionsList>
          {options.map((option) => (
            <S.OptionItem
              key={option.value}
              isSelected={option.value === value}
              onClick={() => handleSelect(option.value)}
              style={{
                color: '#737373',
                fontSize: '14px',
                fontWeight: '400',
              }}
            >
              {option.label}
              {option.value === value && <S.CheckIcon>✓</S.CheckIcon>}
            </S.OptionItem>
          ))}
        </S.OptionsList>
      </BottomSheet>
    </>
  );
};

export default MobileSelect;
